import { createContext } from "react";

export interface ImageFloatRequest {
	pos: number;
	file: string;
	width: number;
	height: number;
	dom: HTMLElement;
}

export interface ImageActions {
	toFloat(request: ImageFloatRequest): void;
}

export const ImageActionsContext = createContext<ImageActions | null>(null);
